import template from './admin-hotel-search-results.html';
import './admin-hotel-search-results.scss';
import {adminStates} from './../../admin-routes';
import adminConstants from '../../admin-constants';

const DIRECTIVE_NAME = AdminHotelSearchResults.DIRECTIVE_NAME = 'ktAdminHotelSearchResults';
export default function AdminHotelSearchResults() {
    return {
        restrict: 'A',
        scope: {
            hotelResults: `=${DIRECTIVE_NAME}`,
        },
        controller: AdminHotelSearchResultsController,
        controllerAs: 'adminHotelSearchResultsCtrl',
        template,
        bindToController: true,
        link: function($scope, elem, attrs, adminHotelSearchResultsCtrl) {
            adminHotelSearchResultsCtrl.$onInit();
        },
    };
}

export function AdminHotelSearchResultsController(
    $timeout,
    $state,
    $location,
    $window,
    adminHotelListService
) {
    'ngInject';
        const vm = this;

        const MIN_AMOUNT_HOTELS_TO_MERGE = 2;

        Object.assign(vm, {
            $onInit,
            loadMore,
            isLoadMoreButtonVisible,
            mergeHotels,
            isMergeHotelsBtnDisabled,
            isMergeHotelsBtnVisible,
            isNoResultsLabelVisible,
            navigateToHotelViewPage,
            isHotelMerged: adminHotelListService.isHotelMerged,
            getSupplierLogoIcon: adminHotelListService.getSupplierLogoIcon,
            getSupplierOrder: adminHotelListService.getSupplierOrder,
            hotelsToMerge: [],
            total: 0,
            isFadeInEnabled: false,
        });

        function $onInit() {
            const {hotelProfiles, total} = vm.hotelResults;
            Object.assign(vm, {hotelProfiles, total});
            enableFadeIn();
        }

        function isMergeHotelsBtnVisible() {
            return vm.hotelProfiles && vm.hotelProfiles.length > 0;
        }

        function isMergeHotelsBtnDisabled() {
            return vm.hotelsToMerge.length < MIN_AMOUNT_HOTELS_TO_MERGE;
        }

        function mergeHotels() {
            if (adminHotelListService.hotelsHaveSameSupplier(vm.hotelProfiles, vm.hotelsToMerge)) {
                adminHotelListService.showCantMergeMessage();
                return;
            }
            adminHotelListService.mergeHotels(vm.hotelsToMerge)
                .then(replaceHotels);
        }

        function replaceHotels(hotel) {
            const lastSelectedIndex = getLastSelectedIndex();
            vm.hotelProfiles.splice(lastSelectedIndex, 0, hotel);
            vm.hotelsToMerge.forEach(removeElement);
            vm.hotelsToMerge = [];
        }

        function removeElement(id) {
            const index = getIndexById(id);
            vm.hotelProfiles.splice(index, 1);
        }

        function getLastSelectedIndex() {
            const lastId = vm.hotelsToMerge[vm.hotelsToMerge.length - 1];
            return getIndexById(lastId);
        }

        function getIndexById(id) {
            return _.findIndex(vm.hotelProfiles, (elem) => elem.id === id);
        }

        function enableFadeIn() {
            $timeout(() => vm.isFadeInEnabled = true, 0);
        }

        function disableFadeIn() {
            $timeout(() => vm.isFadeInEnabled = false, 0);
        }

        function loadMore() {
            disableFadeIn();
            const query = $location.search();
            const {LOAD_MORE_AMOUNT} = adminConstants;
            query.min = parseInt(query.min, 10) + LOAD_MORE_AMOUNT;
            query.max = parseInt(query.max, 10) + LOAD_MORE_AMOUNT;

            adminHotelListService.getHotels(query)
                .then(({hotelProfiles}) => vm.hotelProfiles = [...vm.hotelProfiles, ...hotelProfiles])
                .then(enableFadeIn);
        }

        function isLoadMoreButtonVisible() {
            return vm.hotelProfiles && vm.hotelProfiles.length < vm.total || false;
        }

        function isNoResultsLabelVisible() {
            return !vm.hotelResults || !vm.hotelResults.hotelProfiles || vm.hotelResults.hotelProfiles.length === 0;
        }

        function navigateToHotelViewPage(hotelId) {
            $window.open($state.href(adminStates.HOTEL_VIEW, {hotelId}, {absolute: true}), '_blank');
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-list/admin-hotel-search-results/admin-hotel-search-results-component.js